/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordRequest } from '../../models/change-password-request';
import { ChangePasswordResult } from '../../models/change-password-result';

export interface PostChangePassword$Params {
  body?: ChangePasswordRequest;
}

export function postChangePassword(
  http: HttpClient,
  rootUrl: string,
  params?: PostChangePassword$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ChangePasswordResult>> {
  const rb = new RequestBuilder(rootUrl, postChangePassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangePasswordResult>;
    }),
  );
}

postChangePassword.PATH = '/Authentication/change-password';
